import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { SubjectSubscriber } from 'rxjs/internal/Subject';


@Component({
    selector: 'vertical-form-save',
    template: `<div class="vertical-save" fxLayout="column" fxLayoutGap="10px">
    <button  mat-button (disabled)="!valid" (click)="doPostItem()">
      <mat-icon>done</mat-icon>Salvar
    </button>
    
    <button mat-button (click)="doCancelItem()">
      <mat-icon>cancel</mat-icon>Cancelar
    </button>
    <button *ngIf="canDelete()" mat-button (click)="doDeleteItem()">
      <mat-icon>delete</mat-icon>Excluir
    </button>
    </div>
`,
    styles: [`.vertical-save{
        margin: 10px 20px 10px 0;
    } button{ width:70px; left:1px;   }`]
})
export class VerticalFormSaveComponent implements OnInit {
    @Input()
    valid: boolean = true;
    @Output()
    post: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    cancel: EventEmitter<any> = new EventEmitter<any>();
    constructor() { }

    ngOnInit(): void { }
    doPostItem() {
        this.post.emit();
    }
    doCancelItem() {
        this.cancel.emit();
    }

    @Output()
    delete: EventEmitter<any> = new EventEmitter<any>();

    canDelete() {
        return this.delete.observers.length > 0;
    }
    doDeleteItem(event){
        this.delete.emit(event);
    }
 
}



@Component({
    selector: 'horizontal-form-save',
    template: `<div class="vertical-save" fxLayout="row" fxLayoutGap="10px">
    <button mat-button (disabled)="!valid" (click)="doPostItem()">
      <mat-icon class="mat-18">done</mat-icon>Salvar
    </button>
    <button mat-button (click)="doCancelItem()">Cancelar
      <mat-icon class="mat-18">cancel</mat-icon>
    </button>
    <button *ngIf="canDelete()" mat-button (click)="doDeleteItem()">Excluir
      <mat-icon class="mat-18">delete</mat-icon>
    </button>    
    
    </div>
`,
    styles: [`.vertical-save{
        margin: 10px 20px 10px 0;
    }`]
})
export class HorizontalFormSaveComponent implements OnInit {
    @Input()
    valid: boolean = true;
    @Output()
    post: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    cancel: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    delete: EventEmitter<any> = new EventEmitter<any>();

    canDelete() {
        return this.delete.observers.length > 0;
    }

   doDeleteItem(event){
       this.delete.emit(event);
   }

    constructor() { }

    ngOnInit(): void { }
    doPostItem() {
        this.post.emit();
    }
    doCancelItem() {
        this.cancel.emit();
    }
}


